/*
 * -----------------------------------------------------------------------
 *  <copyright file="add-panel-column.data.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { SelectWithSearchDataArrayInterface } from '@components/core/select-with-categories/select-with-categories.interface';
import { StudyOverviewExtraColumnType } from '@types/graphql-global-types';

export const STEP4_COLUMN_TYPES: SelectWithSearchDataArrayInterface[] = [
    { id: '', text: 'Select a Value' },
    { id: StudyOverviewExtraColumnType.RATE, text: 'Rate' },
    { id: StudyOverviewExtraColumnType.STUDY_MEAN, text: 'Study Mean' },
    { id: StudyOverviewExtraColumnType.STUDY_MEDIAN, text: 'Study Median' },
];
